import e from "./useKey.js";
//#region src/hooks/useEsc.ts
var t = (t) => {
	e((e) => e.key === "Escape" && t(e));
};
//#endregion
export { t as default };

//# sourceMappingURL=useEsc.js.map